import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@mui/material'

import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg'
import useTranslations from '../../../../i18n/useTranslations'
import useStyles from '../../../../ui/modules/shipmentsSearch/styles'
import useShippingsFiltersForm from './useShippingsFiltersForm'
import StatusCode from './StatusCode'
import ClientCenterCode from './ClientCenterCode'
import PostalCode from './PostalCode'
import Country from './Country'
import ServiceType from './ServiceType'
import DateRange from './DateRange'

const FiltersForm = ({
  userCentres,
  countries,
  filters,
  disabledFilterByStatusCode,
  cancel: handleCancelClick,
  confirm: applyFilters,
}) => {
  const classes = useStyles()
  const t = useTranslations()

  const { formik, handleSubmit } = useShippingsFiltersForm(
    applyFilters,
    filters,
    countries,
  )

  return (
    <Box className={classes.content}>
      <Typography
        variant="h2"
        className={clsx(classes.title, 'secondaryTitle', 'decorator')}
      >
        {t('shipping-tracking:find-shipments')}
      </Typography>
      <form onSubmit={handleSubmit} noValidate>
        <Box className={classes.fields}>
          <ClientCenterCode centers={userCentres} {...formik} />
          <StatusCode
            {...formik}
            disabledFilterByStatusCode={disabledFilterByStatusCode}
          />
          <Country countries={countries} {...formik} />
          <PostalCode {...formik} />
          <ServiceType centers={userCentres} {...formik} />
          <DateRange {...formik} />
        </Box>

        <Box className={classes.actionButtons}>
          <Button type="button" variant="outlined" onClick={handleCancelClick}>
            {t('action:cancel')}
          </Button>

          <Button
            className={classes.mainButton}
            type="submit"
            endIcon={<ArrowRight />}
          >
            {t('action:apply-filters')}
          </Button>
        </Box>
      </form>
    </Box>
  )
}

FiltersForm.propTypes = {
  userCentres: PropTypes.oneOfType([
    ClientCenterCode.propTypes.centers,
    ServiceType.propTypes.centers,
  ]),
  countries: PropTypes.array,
  filters: PropTypes.object,
  disabledFilterByStatusCode: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
}

export default FiltersForm
